module.exports = __webpack_public_path__ + "static/media/larry-crayton-cf1cN3ofKUM-unsplash.dda4b468.jpg";